import clsx from 'clsx'
import { defineComponent } from 'vue'

interface Props {
  tData?: string
  class?: string
  for?: string
  disabled?: boolean
}

export default defineComponent((props: Props, context) => {
  return () => (
    <label
      t-data={props.tData}
      for={props.for}
      class={clsx('text-body-1', { 'text-neutral': !props.disabled, 'text-neutral-400': props.disabled }, props.class)}
    >{context.slots.default?.()}
    </label>
  )
}, {
  name: 'VLabel',
  props: ['tData', 'class', 'for', 'disabled']
})
